"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NibbyHappySystemIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const use_mesh_selector_1 = require("../../mesh/use-mesh-selector");
const NibbyHappySystemIcon = _a => {
  var {
      fill = "currentColor"
    } = _a,
    props = __rest(_a, ["fill"]);
  const fillColor = (0, use_mesh_selector_1.useMeshSelector)(fill);
  return (0, jsx_runtime_1.jsxs)("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props, {
    children: [(0, jsx_runtime_1.jsx)("path", {
      fill: fillColor,
      fillRule: "evenodd",
      d: "M.5 2.75A2.75 2.75 0 0 1 3.25 0h18.5a2.75 2.75 0 0 1 2.75 2.75v13.887a2.75 2.75 0 0 1-2.75 2.75h-9.679l-5.814 4.456a.75.75 0 0 1-1.207-.595v-3.86h-1.8a2.75 2.75 0 0 1-2.75-2.75zM3.25 1.5C2.56 1.5 2 2.06 2 2.75v13.887c0 .69.56 1.25 1.25 1.25H5.8a.75.75 0 0 1 .75.75v3.091l4.81-3.686a.75.75 0 0 1 .457-.155h9.933c.69 0 1.25-.56 1.25-1.25V2.75c0-.69-.56-1.25-1.25-1.25z",
      clipRule: "evenodd"
    }), (0, jsx_runtime_1.jsx)("path", {
      fill: fillColor,
      fillRule: "evenodd",
      d: "M8.02 6.623a1.5 1.5 0 0 0-1.366.88.75.75 0 0 1-1.365-.622 3 3 0 0 1 5.462 0 .75.75 0 0 1-1.365.621 1.5 1.5 0 0 0-1.366-.879M17.167 6.623a1.5 1.5 0 0 0-1.366.88.75.75 0 0 1-1.365-.622 3 3 0 0 1 5.463 0 .75.75 0 0 1-1.366.621 1.5 1.5 0 0 0-1.366-.879M8.094 11.89a.75.75 0 0 1 1.06-.017c.901.87 2.126 1.406 3.476 1.406s2.576-.535 3.476-1.406a.75.75 0 1 1 1.043 1.078 6.48 6.48 0 0 1-4.519 1.828 6.48 6.48 0 0 1-4.518-1.828.75.75 0 0 1-.018-1.06",
      clipRule: "evenodd"
    })]
  }));
};
exports.NibbyHappySystemIcon = NibbyHappySystemIcon;